import CtaButtonWithIcon from 'components/formComponents/Base/CtaButtonWithIcon';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styles from './ReportDismissedSection.module.scss';
import { CYPRESS_DATA } from './constants';
import ExcelImportButton from './ExcelImportButton';
import TemplateDownloadButton from './TemplateDownloadButton';
import { TerminatedEmployeeInput } from './types';

type Props = {
  count: number;
  maxCount: number;
  isImporting: boolean;
  employees: TerminatedEmployeeInput[];
  registerDismissedAddBtnText: string;
  importFileBtnText: string;
  downloadTemplateBtnText: string;
  downloadCopyBtnText: string;
  templateFileUrl: string;
  onAdd: () => void;
  onFileSelected: (file: File) => void;
};

const TerminatedEmployeesToolbar = ({
  count,
  maxCount,
  isImporting,
  employees,
  registerDismissedAddBtnText,
  importFileBtnText,
  downloadTemplateBtnText,
  downloadCopyBtnText,
  templateFileUrl,
  onAdd,
  onFileSelected,
}: Props) => (
  <div className={styles.toolbar}>
    <div className={styles.toolbarAction}>
      <CtaButtonWithIcon
        type="button"
        label={registerDismissedAddBtnText}
        Icon={AddCircleOutlineIcon}
        disabled={count >= maxCount}
        onClick={onAdd}
        dataCy={CYPRESS_DATA.addButton}
      />
    </div>
    <ExcelImportButton
      disabled={isImporting}
      onFileSelected={onFileSelected}
      importFileBtnText={importFileBtnText}
    />
    <TemplateDownloadButton
      employees={employees}
      downloadTemplateBtnText={downloadTemplateBtnText}
      downloadCopyBtnText={downloadCopyBtnText}
      templateFileUrl={templateFileUrl}
    />
  </div>
);

export default TerminatedEmployeesToolbar;
